<p-drawer header="Save Report for Mobile" [(visible)]="mobileReportInfo.visible" position="right" [style]="{width: '60vw'}" (onShow)="mobilePreview()">
    <div class="flex">
        <div class="col-6 p-0 pr-4 ">
          <div class="mobileView" *ngIf="!clickOnPreview">
                <div class="mobVBody">
                    <p-table [value]="tableData">
                        <ng-template pTemplate="header">
                            <tr>
                                <th *ngFor="let option of mobileReportInfo.groupByColumnsList">{{ getGroupByColumnInfo(option)?.columnName || 'Unknown Column' }}</th>
                                <th *ngFor="let option of mobileReportInfo.columnsList">{{ getColumnInfo(option)?.columnName || 'Unknown Column' }}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row>
                            <tr>
                                <td *ngFor="let colData of row">{{colData}}</td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td [attr.colspan]="5" class="text-center">
                                    <div class="noData">No records found</div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
          </div>
          <div class="mobileView" *ngIf="clickOnPreview">
            <div class="mobVBody">
                <div class="noData">Click on Mobile Preview to view the report</div>
            </div>
          </div>
        </div>
        <div class="col-5 p-0 ml-auto">
            <div class="mb-3 ml-2">
                <div class="field">
                    <div *ngIf="mobileReportInfo.reportType != ReportType.DETAILED_REPORT">
                        <div class="sectLab mb-3">Group Columns</div>
                        <p-multiselect [options]="getGroupByColumns()" optionLabel="name" optionValue="code"
                            placeholder="Select Columns" styleClass="w-full md:w-80" [maxSelectedLabels]="1" [maxSelectedItems]="1" [showToggleAll]="true" [showClear]="true" [filter]="true" [(ngModel)]="mobileReportInfo.groupByColumnsList" (onChange)="onGroupByFiltersChange($event)"/>
                    </div>
                </div>
                <div class="field">
                    <div class="OrdList" *ngIf="getGroupByColumns().length > 0">
                        <div class="">
                            <div *ngFor="let option of mobileReportInfo.groupByColumnsList; let i = index"
                                class="flex w-full align-items-center pListing" draggable="true"
                                (dragstart)="onDragStart($event, i, 'groupByFilters')" (dragend)="onDragEnd($event)"
                                (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                                (drop)="onDrop($event, i, 'groupByFilters')" style="cursor: move;"> 
                                <!-- Display Mode -->
                                <div *ngIf="editingItemCode !== option" class="flex w-full align-items-center">
                                    <div class="mr-2"><img src="assets/images/v-dotts.svg" alt=""></div>
                                    <div class="flex-1">{{ getGroupByColumnInfo(option)?.columnName || 'Unknown Column' }}
                                    </div>
                                    <div class="ordLAct">
                                        <a class="cursor-pointer"
                                            (click)="startEditing(option, getGroupByColumnInfo(option)?.columnName)">
                                            <i class="pi pi-pencil"></i>
                                        </a>
                                        <a class="cursor-pointer" (click)="removeGroupByFilter(option)">
                                            <i class="pi pi-times"></i>
                                        </a>
                                    </div>
                                </div>

                                <!-- Edit Mode -->
                                <div *ngIf="editingItemCode === option"
                                    class="field flex w-full align-items-center ordLEdit mb-0">
                                    <input type="text" id="editColumn_{{option}}" pInputText class="w-full"
                                        [(ngModel)]="editColumn" [ngModelOptions]="{standalone: true}"
                                        (keyup.enter)="updateItemName(option, editColumn, 'groupByFilters')"
                                        (keyup.escape)="stopEditing()" />
                                    <div class="ordLAct">
                                        <a class="cursor-pointer" (click)="updateItemName(option, editColumn, 'groupByFilters')">
                                            <i class="pi pi-save"></i>
                                        </a>
                                        <a class="cursor-pointer" (click)="stopEditing()">
                                            <i class="pi pi-times"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <div class="sectLab mb-3">Choose Columns</div>
                    <div >
                        <p-multiselect [options]="getChooseColumns()" optionValue="code" optionLabel="name" placeholder="Select Columns" styleClass="w-full md:w-80" [maxSelectedLabels]="3" [showToggleAll]="false" [showClear]="true" [filter]="true" [(ngModel)]="mobileReportInfo.columnsList" (onChange)="onColumnsChange($event)" (onClear)="onColumnsChange($event)" />
                    </div>
                </div>
                <div class="field">
                    <div class="OrdList sCol"
                        *ngIf="getChooseColumns().length > 0">
                        <div class="">
                            <div *ngFor="let option of mobileReportInfo.columnsList; let i = index"
                                class="flex w-full align-items-center pListing" draggable="true"
                                (dragstart)="onDragStart($event, i, 'columns')" (dragend)="onDragEnd($event)"
                                (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                                (drop)="onDrop($event, i, 'columns')" style="cursor: move;">
                                <!-- Display Mode -->
                                <div *ngIf="editingItemCode !== option" class="flex w-full align-items-center">
                                    <div class="mr-2"><img src="assets/images/v-dotts.svg" alt=""></div>
                                    <div class="flex-1">{{ getColumnInfo(option)?.columnName || 'Unknown Column' }}
                                    </div>
                                    <div class="ordLAct">
                                        <a class="cursor-pointer"
                                            (click)="startEditing(option, getColumnInfo(option)?.columnName)">
                                            <i class="pi pi-pencil"></i>
                                        </a>
                                        <a class="cursor-pointer" (click)="removeColumn(option)">
                                            <i class="pi pi-times"></i>
                                        </a>
                                    </div>
                                </div>

                                <!-- Edit Mode -->
                                <div *ngIf="editingItemCode === option"
                                    class="field flex w-full align-items-center ordLEdit mb-0">
                                    <input type="text" id="editColumn_{{option}}" pInputText class="w-full"
                                        [(ngModel)]="editColumn" [ngModelOptions]="{standalone: true}"
                                        (keyup.enter)="updateItemName(option, editColumn, 'columns')"
                                        (keyup.escape)="stopEditing()" />
                                    <div class="ordLAct">
                                        <a class="cursor-pointer" (click)="updateItemName(option, editColumn, 'columns')">
                                            <i class="pi pi-save"></i>
                                        </a>
                                        <a class="cursor-pointer" (click)="stopEditing()">
                                            <i class="pi pi-times"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
        </div>
        
    </div>
    <ng-template #footer>
        <div class="flex items-center gap-2">
            <button pButton label="Mobile Preview" pButton (click)="mobilePreview()"></button>
            <button pButton label="Save as a Mobile Report" pButton (click)="saveAsMobileReport()"></button>
            <button pButton label="Cancel" (click)="mobileReportInfo.visible = false" [outlined]="true"  severity="secondary"></button>
        </div>
    </ng-template>
</p-drawer>